// extracted by mini-css-extract-plugin
module.exports = {"cookiesSettings":"Routes_cookiesSettings__x3T5l","copyright":"Routes_copyright__sUP72"};